var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[_c('VueApexCharts',{attrs:{"type":"area","height":"350","options":_vm.chartOptions,"series":_vm.series}}),(_vm.loading)?_c('div',{class:_vm.lds_ellipsis,style:({ width:_vm.filter_width,height: 330.7+'px', bottom: 5+'px' })},[_vm._m(0)]):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ellipsiss"},[_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }